<app-container [noPadding]="handsetService.isXs" fxLayoutAlign="center" maxWidth="552px" ngClass.xs="xs" fxLayout="row">
  <app-card
    [titleStyle]="{'text-align': 'center', 'margin': '3rem'}"
    [title]="'Konto usunięte.'">
    <div header>
      <app-icon [name]="'session_expired'" [height]="120" [width]="121">
      </app-icon>
    </div>

    <div content>
      <p class=" text-center">
        Twoje konto zostało usunięte. <br>
        Będzie nam Ciebie brakować!
      </p>
    </div>
    <div buttons>
      <div class="buttons-line-2">
        <button mat-raised-button color="accent" (click)="onGoToMain()">Strona główna</button>
      </div>
    </div>
  </app-card>
</app-container>


